import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {ModalModule} from "ng2-bootstrap";

import {LoaderComponent} from "../core/loader/loader.component";
import {LoaderService} from "../core/loader/loader.service";
//import {AuthenticationService} from "./services/authentication.service";

import {UploaderService} from "./services/uploader.service";
import {CdnService} from "./services/cdn.service";
import {FileDirective} from "./directives/file.directive";
import {IframeAutoHeightDirective} from "./directives/iframe-autoheight.directive";
import {SimpleCrudComponent} from './simple-crud/simple-crud.component';
import {DataTableComponent} from "./data-table/data.table.component";


/**
 * Re-exporting modules
 *
 * Declare there modules/components/directives/pipes
 * that can be shared in many other modules
 *
 * Don't provide app-wide singleton services here
 */
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule.forRoot()
    ],
    declarations: [
        LoaderComponent,
        FileDirective,
        IframeAutoHeightDirective,
        SimpleCrudComponent,
        DataTableComponent
    ],
    exports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        LoaderComponent,
        ModalModule,
        FileDirective,
        IframeAutoHeightDirective,
        DataTableComponent
    ],
    providers: [
        LoaderService,
        // AuthenticationService,
        UploaderService,
        CdnService
    ]
})
export class SharedModule {
}


// WEBPACK FOOTER //
// /code/frontend/src/app/shared/shared.module.ts